import GetCategoriesQuery from './Categories';

export default GetCategoriesQuery;


// WEBPACK FOOTER //
// ./src/components/Query/Categories/index.ts